import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const employeesApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/employeeList',
      method: 'GET',
      useToken: true,
      title: 'Employee - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeCreate',
      method: 'POST',
      useToken: true,
      title: 'Employee - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Employee - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/employeeDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Employee - Delete',
      params,
    }),
  changePassword: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeChangePasswordFull',
      method: 'POST',
      useToken: true,
      title: 'Change Password Full',
      data,
    }),
  addPayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeAddPayment',
      method: 'POST',
      useToken: true,
      title: 'Add Payment',
      data,
    }),
  removePayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeRemovePayment',
      method: 'POST',
      useToken: true,
      title: 'Remove Payment',
      data,
    }),
  report: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_ENTRY}`,
      method: 'GET',
      useToken: true,
      title: 'Employee Report Trip',
      params,
    }),
  dailyReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_DAILY_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'Employee Daily Report Trip',
      params,
    }),
  createMany: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeCreateList',
      method: 'POST',
      useToken: true,
      title: 'Employee - Create',
      data,
    }),
  getEmployeeSettings: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/employeeSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Employee - Get settings',
      params,
    }),
  employeeRestrictionList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/restrictionList',
      method: 'GET',
      useToken: true,
      title: 'Employee - Get restrictionList',
      params,
    }),
  employeeRating: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserTripEvaluationList',
      method: 'GET',
      useToken: true,
      title: 'Employee - Get appUserTripEvaluationList',
      params,
    }),
  updateEmployeeSettings: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeSettingsUpdate',
      method: 'POST',
      useToken: true,
      title: 'Employee - settings - Update',
      data,
    }),
};

export { employeesApi };
export default employeesApi;
